import { styled } from '@material-ui/core';
import { BaseLabelValueFieldCard } from '../../../../../styled';

export const LabelValueFieldCard = styled(BaseLabelValueFieldCard)({
  backgroundColor: '#F8F9FA'
});
